import HomeIcon from '@mui/icons-material/Home';
import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import ViewSidebarOutlinedIcon from '@mui/icons-material/ViewSidebarOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import { apiRequest } from './common';

export const Menus = [{
    label: 'Home', icon: <HomeIcon style={{ color: 'white' }} />, path: '/app/home/dashboard'
}, {
    label: 'Projects', icon: <CorporateFareOutlinedIcon style={{ color: 'white' }} />, path: '/app/projects'
}, {
    label: 'Templates', icon: <ViewSidebarOutlinedIcon style={{ color: 'white' }} />, path: '/app/templates'
}, {
    label: 'Catalog', icon: <ImportContactsOutlinedIcon style={{ color: 'white' }} />, path: '/app/catalog'
}, {
    label: 'Admin', icon: <VpnKeyOutlinedIcon style={{ color: 'white' }} />, path: '/app/user'
},]

export const countries = [
    { name: "Afghanistan", code: "AF" },
    { name: "Albania", code: "AL" },
    { name: "Algeria", code: "DZ" },
    { name: "Andorra", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia", code: "BO" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Brazil", code: "BR" },
    { name: "Brunei", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cabo Verde", code: "CV" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Central African Republic", code: "CF" },
    { name: "Chad", code: "TD" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros", code: "KM" },
    { name: "Congo (Congo-Brazzaville)", code: "CG" },
    { name: "Congo (Democratic Republic of the Congo)", code: "CD" },
    { name: "Costa Rica", code: "CR" },
    { name: "Croatia", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Cyprus", code: "CY" },
    { name: "Czech Republic (Czechia)", code: "CZ" },
    { name: "Denmark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Equatorial Guinea", code: "GQ" },
    { name: "Eritrea", code: "ER" },
    { name: "Estonia", code: "EE" },
    { name: "Eswatini (fmr. 'Swaziland')", code: "SZ" },
    { name: "Ethiopia", code: "ET" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Greece", code: "GR" },
    { name: "Grenada", code: "GD" },
    { name: "Guatemala", code: "GT" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Honduras", code: "HN" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iran", code: "IR" },
    { name: "Iraq", code: "IQ" },
    { name: "Ireland", code: "IE" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kiribati", code: "KI" },
    { name: "Korea (North)", code: "KP" },
    { name: "Korea (South)", code: "KR" },
    { name: "Kuwait", code: "KW" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: "Laos", code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libya", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Marshall Islands", code: "MH" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia", code: "FM" },
    { name: "Moldova", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montenegro", code: "ME" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Myanmar (formerly Burma)", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands", code: "NL" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "North Macedonia", code: "MK" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Palau", code: "PW" },
    { name: "Panama", code: "PA" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Qatar", code: "QA" },
    { name: "Romania", code: "RO" },
    { name: "Russia", code: "RU" },
    { name: "Rwanda", code: "RW" },
    { name: "Saint Kitts and Nevis", code: "KN" },
    { name: "Saint Lucia", code: "LC" },
    { name: "Saint Vincent and the Grenadines", code: "VC" },
    { name: "Samoa", code: "WS" },
    { name: "San Marino", code: "SM" },
    { name: "Sao Tome and Principe", code: "ST" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Serbia", code: "RS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Solomon Islands", code: "SB" },
    { name: "Somalia", code: "SO" },
    { name: "South Africa", code: "ZA" },
    { name: "South Sudan", code: "SS" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sudan", code: "SD" },
    { name: "Suriname", code: "SR" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Syria", code: "SY" },
    { name: "Taiwan", code: "TW" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Tanzania", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Turkmenistan", code: "TM" },
    { name: "Tuvalu", code: "TV" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "United Kingdom", code: "GB" },
    { name: "United States of America", code: "US" },
    { name: "Uruguay", code: "UY" },
    { name: "Uzbekistan", code: "UZ" },
    { name: "Vanuatu", code: "VU" },
    { name: "Vatican City (Holy See)", code: "VA" },
    { name: "Venezuela", code: "VE" },
    { name: "Vietnam", code: "VN" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" }
];

export const Responsibility = [{
    name: 'Owner', value: 'owner'
}, {
    name: 'Vendor', value: 'vendor'
}, {
    name: 'Contactor', value: 'contactor'
}];

export const ArchitecturalCode = [{
    name: '01-Fixed Equipment', value: '1'
}, {
    name: '02-Movable Electrical', value: '2'
}, {
    name: '03-Movable Non-Electrical', value: '3'
}, {
    name: '04-Instruments', value: '4'
}, {
    name: '05-Furniture', value: '5'
}, {
    name: '06-IT Computers', value: '6'
}, {
    name: '07- Security', value: '7'
}, {
    name: '08-Unassigned', value: '8'
}, {
    name: '09-Unassigned', value: '9'
}, {
    name: '10-Unassigned', value: '10'
}];

export const LifeExpectancy = [{
    name: '1', value: '1'
}, {
    name: '2', value: '2'
}, {
    name: '3', value: '3'
}, {
    name: '4', value: '4'
}, {
    name: '5', value: '5'
}, {
    name: '6', value: '6'
}, {
    name: '7', value: '7'
}, {
    name: '8', value: '8'
}, {
    name: '9', value: '9'
}, {
    name: '10', value: '10'
}, {
    name: '11', value: '11'
}, {
    name: '12', value: '12'
}, {
    name: '13', value: '13'
}, {
    name: '14', value: '14'
}, {
    name: '15', value: '15'
}, {
    name: '16', value: '16'
}, {
    name: '17', value: '17'
}, {
    name: '18', value: '18'
}, {
    name: '19', value: '19'
}, {
    name: '20', value: '20'
}];

export const PriceType = [
    { "name": 'List', "value": 'list' },
    { "name": "Estimate", "value": "estimate" },
    { "name": "Budget", "value": "budget" },
    { "name": "Quote", "value": "quote" },
    { "name": "Contract", "value": "contract" },
    { "name": "Project", "value": "project" },
    { "name": "Vendor", "value": "vendor" }
];

export const ProductStatus = [{
    name: 'Draft', value: 'draft'
}, {
    name: 'Existing', value: 'existing'
}];

export const Discontinues = [{
    name: 'YES', value: 'yes'
}, {
    name: 'NO', value: 'no'
}];

export const CopyTemplateType = [{
    name: 'Mvedas', value: 'public'
}, {
    name: 'Personal', value: 'personal'
}];

export const TemplateType = [{
    name: 'Mvedas', value: 'public'
}, {
    name: 'Personal', value: 'personal'
}, {
    name: 'Organization', value: 'organization'
}];

export const getSize = (units, size) => {
    if (units === 'matric') {
        return (
            <span>{size || 0} mm ({Number(size / 25.4).toFixed(2)} in)</span>
        );
    } else if (units === 'imperial') {
        return (
            <span>{size || 0} in ({Math.ceil(Number(size * 25.4).toFixed(2))} mm)</span>
        );
    }
}

export const getWeight = (units, size) => {
    if (units === 'matric') {
        return (
            <span>{size || 0} kg ({Number(size * 2.205).toFixed(2)} lbs)</span>
        );
    } else if (units === 'imperial') {
        return (
            <span>{size || 0} lbs ({Math.ceil(Number(size / 2.205).toFixed(2))} kg)</span>
        );
    }
}

export const getProjectSize = (units, size) => {
    if (units === 'matric') {
        return `${Intl.NumberFormat('en-IN').format(size)} sq.m (${Intl.NumberFormat('en-IN').format((size * 10.764).toFixed(2))} sq.ft)`;
    } else if (units === 'imperial') {
        return `${Intl.NumberFormat('en-IN').format(size)} sq.ft (${Intl.NumberFormat('en-IN').format(Math.ceil(Number(size / 10.764).toFixed(2)))} sq.m)`;
    }
}

export const buildTree = (data, innerLabel, selectedData, isMove) => {
    if (innerLabel === 'Department') {
        return [{
            value: data?.project_id,
            label: data?.name,
            children: data?.buildings?.map((building) => ({
                value: building?.building_id,
                label: building.building_name,
                children: building?.levels?.map((level) => ({
                    value: level?.level_id,
                    label: level.level_name,
                }))
            }))
        }];
    } else if (innerLabel === 'Room') {
        if (isMove) {
            return [{
                value: data?.project_id,
                label: data?.name,
                children: data?.buildings?.map((building) => ({
                    value: building?.building_id,
                    label: building.building_name,
                    children: building?.levels?.map((level) => ({
                        value: level?.level_id,
                        label: level.level_name,
                        children: level?.departments?.filter((a) => !selectedData.find((b) => b.department_id === a.department_id))?.map((department) => ({
                            value: department.department_id,
                            label: department.department_name,
                        }))
                    }))
                }))
            }];
        } else {
            return [{
                value: data?.project_id,
                label: data?.name,
                children: data?.buildings?.map((building) => ({
                    value: building?.building_id,
                    label: building.building_name,
                    children: building?.levels?.map((level) => ({
                        value: level?.level_id,
                        label: level.level_name,
                        children: level?.departments?.map((department) => ({
                            value: department.department_id,
                            label: department.department_name,
                        }))
                    }))
                }))
            }];
        }
    } else {
        if (isMove) {
            return [{
                value: data?.project_id,
                label: data?.name,
                children: data?.buildings?.map((building) => ({
                    value: building?.building_id,
                    label: building.building_name,
                    children: building?.levels?.map((level) => ({
                        value: level?.level_id,
                        label: level.level_name,
                        children: level?.departments?.map((department) => ({
                            value: department.department_id,
                            label: department.department_name,
                            children: department?.project_rooms?.filter((a) => !selectedData.find((b) => b.room_id === a.room_id))?.map((room) => ({
                                value: room.room_id,
                                label: room.room_name
                            }))
                        }))
                    }))
                }))
            }];
        } else {
            return [{
                value: data?.project_id,
                label: data?.name,
                children: data?.buildings?.map((building) => ({
                    value: building?.building_id,
                    label: building.building_name,
                    children: building?.levels?.map((level) => ({
                        value: level?.level_id,
                        label: level.level_name,
                        children: level?.departments?.map((department) => ({
                            value: department.department_id,
                            label: department.department_name,
                            children: department?.project_rooms?.map((room) => ({
                                value: room.room_id,
                                label: room.room_name
                            }))
                        }))
                    }))
                }))
            }];
        }
    }
};

export const getAllNodeIds = (nodes) => {
    let allIds = [];
    const recursiveCollectIds = (nodeList) => {
        nodeList.forEach(node => {
            allIds.push(node.value);
            if (node.children) {
                recursiveCollectIds(node.children);
            }
        });
    };
    recursiveCollectIds(nodes);
    return allIds;
};

export const getNormalData = (data, innerLabel) => {
    const result = [];
    if (innerLabel === 'Department') {
        data.buildings?.forEach(building => {
            building.levels.forEach(level => {
                result.push({
                    level_id: level?.level_id,
                    level_name: level?.level_name,
                    building_name: building?.building_name,
                    project_name: data?.name
                });
            });
        });
    } else if (innerLabel === 'Room') {
        data.buildings?.forEach(building => {
            building.levels.forEach(level => {
                level.departments.forEach(department => {
                    result.push({
                        department_id: department?.department_id,
                        department_name: department?.department_name,
                        level_name: level?.level_name,
                        building_name: building?.building_name,
                        project_name: data?.name
                    });
                });
            });
        });
    } else {
        data.buildings?.forEach(building => {
            building.levels.forEach(level => {
                level.departments.forEach(department => {
                    department.project_rooms.forEach(room => {
                        result.push({
                            quantity: 1,
                            room_id: room?.room_id,
                            department_name: department?.department_name,
                            room_name: room.room_name,
                            room_no: room.room_no,
                            level_name: level?.level_name,
                            building_name: building?.building_name,
                            project_name: data?.name
                        });
                    });
                });
            });
        });
    }
    return result;
}

export const handleUndefined = (value1, value2) => {
    return value1 !== undefined ? value1 : value2
}

export const DepartmentFields = [
    {
        "field": "Architectural Code",
        "description": "Reset returns to software default",
        "reset_enabled": true,
        "label": "architectural_code"
    },
    {
        "field": "Area Phase",
        "description": "Reset sets items to destination project default",
        "reset_enabled": false,
        "label": "area_phase"
    },
    {
        "field": "Bid Group",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "bid_group"
    },
    {
        "field": "Budget",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "budget"
    },
    {
        "field": "Cost Center",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "cost_center"
    },
    {
        "field": "Custom 1",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "custom_1"
    },
    {
        "field": "Custom 2",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "custom_2"
    },
    {
        "field": "Inventory ID",
        "description": "Reset clears all Item IDs",
        "reset_enabled": true,
        "label": "inventory_id"
    },
    {
        "field": "Item Notes",
        "description": "Reset clears all Item notes",
        "reset_enabled": true,
        "label": "item_notes"
    },
    {
        "field": "Funding Source",
        "description": "Reset will return field value to project default",
        "reset_enabled": true,
        "label": "funding_source"
    },
    {
        "field": "Need By Date",
        "description": "Reset inherits value based on destination project",
        "reset_enabled": true,
        "label": "need_by_date"
    },
    {
        "field": "Price",
        "description": "Reset restores all prices to current List",
        "reset_enabled": true,
        "label": "price"
    },
    {
        "field": "Item Status",
        "description": "Reset resets field value to Project default",
        "reset_enabled": true,
        "label": "item_status"
    },
    {
        "field": "Product",
        "description": "Reset sets all products to Unspecified",
        "reset_enabled": true,
        "label": "product"
    },
    {
        "field": "Responsibility",
        "description": "Reset returns all to software default",
        "reset_enabled": true,
        "label": "responsibilitiy"
    },
    {
        "field": "Room Notes",
        "description": "Reset clears all notes",
        "reset_enabled": true,
        "label": "room_notes"
    },
    {
        "field": "Room Signage",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "room_signage"
    },
    {
        "field": "Room Tag",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "room_tag"
    }
]

export const RoomFields = [
    {
        "field": "Architectural Code",
        "description": "Reset returns to software default",
        "reset_enabled": true,
        "label": "architectural_code"
    },
    {
        "field": "Area Phase",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "area_phase"
    },
    {
        "field": "Bid Group",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "bid_group"
    },
    {
        "field": "Budget",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "budget"
    },
    {
        "field": "Cost Center",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "cost_center"
    },
    {
        "field": "Custom 1",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "custom_1"
    },
    {
        "field": "Custom 2",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "custom_2"
    },
    {
        "field": "Inventory ID",
        "description": "Reset clears all Item IDs",
        "reset_enabled": true,
        "label": "inventory_id"
    },
    {
        "field": "Item Notes",
        "description": "Reset clears all Item notes",
        "reset_enabled": true,
        "label": "item_notes"
    },
    {
        "field": "Funding Source",
        "description": "Reset will return field value to project default",
        "reset_enabled": true,
        "label": "funding_source"
    },
    {
        "field": "Need By Date",
        "description": "Reset inherits value based on destination project",
        "reset_enabled": true,
        "label": "need_by_date"
    },
    {
        "field": "Price",
        "description": "Reset restores all prices to current List",
        "reset_enabled": true,
        "label": "price"
    },
    {
        "field": "Item Status",
        "description": "Reset resets field value to Project default",
        "reset_enabled": true,
        "label": "item_status"
    },
    {
        "field": "Product",
        "description": "Reset sets all products to Unspecified",
        "reset_enabled": true,
        "label": "product"
    },
    {
        "field": "Responsibility",
        "description": "Reset returns all to software default",
        "reset_enabled": true,
        "label": "responsibilitiy"
    },
    {
        "field": "Room Notes",
        "description": "Reset clears all notes",
        "reset_enabled": true,
        "label": "room_notes"
    },
    {
        "field": "Room Signage",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "room_signage"
    },
    {
        "field": "Room Tag",
        "description": "Reset clears field values",
        "reset_enabled": true,
        "label": "room_tag"
    }
]

export const ItemFields = [
    {
        "field": "Architectural Code",
        "description": "Reset returns to software default",
        "reset_enabled": true,
        "label": "architectural_code"
    },
    {
        "field": "Area Phase",
        "description": "Reset sets items to destination project default",
        "reset_enabled": false,
        "label": "area_phase"
    },
    {
        "field": "Bid Group",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "bid_group"
    },
    {
        "field": "Budget",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "budget"
    },
    {
        "field": "Cost Center",
        "description": "Reset sets items to destination project default",
        "reset_enabled": true,
        "label": "cost_center"
    },
    {
        "field": "Custom 1",
        "description": "Reset clears field values",
        "reset_enabled": false,
        "label": "custom_1"
    },
    {
        "field": "Custom 2",
        "description": "Reset clears field values",
        "reset_enabled": false,
        "label": "custom_2"
    },
    {
        "field": "Item-Scope Documents",
        "description": "Reset removes all item-scope documents",
        "reset_enabled": true,
        "label": "document_scope"
    },
    {
        "field": "Inventory ID",
        "description": "Reset clears all Item IDs",
        "reset_enabled": false,
        "label": "inventory_id"
    },
    {
        "field": "Item Notes",
        "description": "Reset clears all Item notes",
        "reset_enabled": true,
        "label": "item_notes"
    },
    {
        "field": "Funding Source",
        "description": "Reset will return field value to project default",
        "reset_enabled": true,
        "label": "funding_source"
    },
    {
        "field": "Need By Date",
        "description": "Reset inherits value based on destination project",
        "reset_enabled": true,
        "label": "need_by_date"
    },
    {
        "field": "Price",
        "description": "Reset restores all prices to current List",
        "reset_enabled": true,
        "label": "price"
    },
    {
        "field": "Item Status",
        "description": "Reset resets field value to Project default",
        "reset_enabled": true,
        "label": "item_status"
    },
    {
        "field": "Product",
        "description": "Reset sets all products to Unspecified",
        "reset_enabled": true,
        "label": "product"
    },
    {
        "field": "Responsibility",
        "description": "Reset returns all to software default",
        "reset_enabled": true,
        "label": "responsibilitiy"
    }
]

export const Addition = {
    tax: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            value: null
        }
    },
    installation: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            scope: 'project',
            type: 'rate',
            value: null
        }
    },
    storage: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            scope: 'project',
            type: 'rate',
            value: null
        }
    },
    freight: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            scope: 'project',
            type: 'rate',
            value: null
        }
    },
    fees: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            scope: 'project',
            type: 'rate',
            value: null
        }
    },
    contingency: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            type: 'rate',
            value: null
        }
    },
    inflation: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            type: 'rate',
            value: null
        }
    }
};

export const Deductions = {
    discount: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            scope: 'project',
            type: 'rate',
            value: null
        }
    },
    reuse: {
        approved: {
            type: 'rate',
            value: null,
        },
        actual: {
            scope: 'project',
            type: 'rate',
            value: null
        }
    },
};

export const ReportType = {
    1: 'budgetsummarybydepartment',
    2: 'budgetsummarybydepartmentarchcode',
    3: 'budgetsummarybydepartmentareaphase',
    4: 'budgetsummarybydepartmentfundingsource',
    5: 'budgetsummarybyitemareaphase',
    6: 'budgetsummarybyitembudget',
    7: 'budgetsummarybyitemfundingsource',
    8: 'budgetsummarybyitemstage',
    9: 'budgetsummarybyitemstatus',
    10: 'budgetsummarybyitemoverunder',
    11: 'budgetsummarybymfgbudget',
    12: 'budgetsummarybymfgfundingsource',
    13: 'datasheet',
    14: 'datasheettablecontent',
    15: 'itemdetails',
    16: 'itemlocation',
    17: 'itemspecification',
    18: 'itemsummary',
    19: 'pointintimeitemcomparisonreport',
    20: 'pointintimebudgetcomparisonreport',
    21: 'projectcertificatesdata',
    22: 'projectitemsdata',
    23: 'roomlistingwithprice',
    24: 'roomlistingwithoutprice',
    25: 'roombyroomwithprice',
    26: 'roombyroomwithoutprice',
    27: 'roomspecification',
    28: 'budgetforecast',
    29: 'roomdatasheetreport',
    30: 'purchaseactionreport',
    31: 'requisitionreport',
    32: 'bidcamparisonreport',
    33: 'rfqreport',
    34: 'poreport',
    35: 'requisitionapprovalreport',
    36: 'biddingapprovalreport',
    37: 'rfqapprovalreport',
    38: 'poapprovalreport',
    39: 'procurementschedulereport',
    40: 'posummaryreport',
    41: 'Project History'
}

export const ReportFormats = [{
    isExcel: true,
    isPdf: false,
    reportName: 'Budget Forcast',
    detail: 'A budget forcast report showing grouping for Department, Item Status, Priority, Funding Source and Fiscal Year.',
    children: [],
    type: ReportType[28]
}, {
    isExcel: false,
    isPdf: false,
    reportName: 'Budget Summary Reports',
    detail: '--',
    children: [{
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Department',
        detail: '--',
        type: ReportType[1]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Departments / Architectural Code',
        detail: '--',
        type: ReportType[2]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Departments / Area / Phase',
        detail: '--',
        type: ReportType[3]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Departments / Funding Source',
        detail: '--',
        type: ReportType[4]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Items / Area / Phase',
        detail: '--',
        type: ReportType[5]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Items / Budgets',
        detail: '--',
        type: ReportType[6]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Items / Funding Source',
        detail: '--',
        type: ReportType[7]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Items / Stage',
        detail: '--',
        type: ReportType[8]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Items / Status',
        detail: '--',
        type: ReportType[9]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Items / Over / Under',
        detail: '--',
        type: ReportType[10]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Manufacturer / Budgets',
        detail: '--',
        type: ReportType[11]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Budget Summary By Manufacturer / Funding Source',
        detail: '--',
        type: ReportType[12]
    }],
}, {
    isExcel: false,
    isPdf: false,
    reportName: 'Data Sheets Reports',
    detail: '--',
    children: [{
        isExcel: false,
        isPdf: true,
        reportName: 'DataSheets',
        detail: 'A datasheet is all the spec sheets for each item of your project collected together into one report.',
        type: ReportType[13]
    }, {
        isExcel: false,
        isPdf: true,
        reportName: 'DataSheets - Table Of Contents',
        detail: 'This report is a listing of all items in the project showing various item IDs, descriptions, and furnish/install responsibilities.',
        type: ReportType[14]
    }, {
        isExcel: false,
        isPdf: true,
        reportName: 'Room DataSheet Report',
        detail: '--',
        type: ReportType[29]
    }]
}, {
    isExcel: false,
    isPdf: false,
    reportName: 'Item Reports',
    detail: '--',
    children: [{
        isExcel: true,
        isPdf: true,
        reportName: 'Item Details',
        detail: '--',
        type: ReportType[15]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Item Location',
        detail: '--',
        type: ReportType[16]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Item Sepcifications',
        detail: '--',
        type: ReportType[17]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Item Summary',
        detail: '--',
        type: ReportType[18]
    }
    ]
},
{
    isExcel: false,
    isPdf: false,
    reportName: 'Point In Time Comparison Reports',
    detail: '--',
    children: [{
        isExcel: true,
        isPdf: true,
        reportName: 'Point In Time Item Comparison',
        detail: '--',
        type: ReportType[19]
    }, {
        isExcel: true,
        isPdf: false,
        reportName: 'Point In Time Budget Comparison',
        detail: '--',
        type: ReportType[20]
    }]
}, 
{
    isExcel: false,
    isPdf: false,
    reportName: 'Project Reports',
    detail: '--',
    children: [{
        isExcel: true,
        isPdf: true,
        reportName: 'Project Certificate of Need Summary Data',
        detail: '--',
        type: ReportType[21]
    }, {
        isExcel: true,
        isPdf: true,
        reportName: 'Project Item Summary Data',
        detail: '--',
        type: ReportType[22]
    }]
}, {
    isExcel: false,
    isPdf: false,
    reportName: 'Rooms Reports',
    detail: '--',
    children: [
        {
            isExcel: true,
            isPdf: true,
            reportName: 'Room By Room Listing With Pricing',
            detail: '--',
            type: ReportType[23]
        }, {
            isExcel: true,
            isPdf: true,
            reportName: 'Room By Room Listing Without Pricing',
            detail: '--',
            type: ReportType[24]
        }, {
            isExcel: true,
            isPdf: true,
            reportName: 'Room By Room Detail With Pricing',
            detail: '--',
            type: ReportType[25]
        }, {
            isExcel: true,
            isPdf: true,
            reportName: 'Room By Room Detail Without Pricing',
            detail: '--',
            type: ReportType[26]
        }, {
            isExcel: true,
            isPdf: true,
            reportName: 'Room By Room Detail Specification',
            detail: '--',
            type: ReportType[27]
        },
    ]
}, {
    isExcel: false,
    isPdf: false,
    reportName: 'Procurement Reports',
    detail: '--',
    children: [
        {
            isExcel: false,
            isPdf: true,
            reportName: 'Requisition Details Reports',
            detail: '--',
            type: ReportType[31]
        }, {
            isExcel: false,
            isPdf: true,
            reportName: 'Requisition Approval Reports',
            detail: '--',
            type: ReportType[35]
        }, {
            isExcel: true,
            isPdf: true,
            reportName: 'Bid Comparison Reports',
            detail: '--',
            type: ReportType[32]
        }, {
            isExcel: false,
            isPdf: true,
            reportName: 'Bidding Approval Reports',
            detail: '--',
            type: ReportType[36]
        }, {
            isExcel: false,
            isPdf: true,
            reportName: 'Request For Quote Details Reports',
            detail: '--',
            type: ReportType[33]
        }, {
            isExcel: false,
            isPdf: true,
            reportName: 'Request For Quote Approval Reports',
            detail: '--',
            type: ReportType[37]
        }, {
            isExcel: false,
            isPdf: true,
            reportName: 'Purchase Order Details Reports',
            detail: '--',
            type: ReportType[34]
        }, {
            isExcel: false,
            isPdf: true,
            reportName: 'Purchase Order Approval Reports',
            detail: '--',
            type: ReportType[38]
        },
        {
            isExcel: true,
            isPdf: false,
            reportName: 'Purchase Actions Reports',
            detail: '--',
            type: ReportType[30]
        },
        {
            isExcel: true,
            isPdf: true,
            reportName: 'Procurement Schedule Reports',
            detail: '--',
            type: ReportType[39]
        },
        {
            isExcel: true,
            isPdf: true,
            reportName: 'PO Summary Reports',
            detail: '--',
            type: ReportType[40]
        },
    ]
}, {
    isExcel: true,
    isPdf: false,
    reportName: 'History Report',
    detail: '--',
    children: [],
    type: ReportType[41]
}];

export const idsLayout = {
    tasks: [
        { id: 'category', content: 'Category' },
        { id: 'subcategory', content: 'Subcategory' },
        { id: 'description', content: 'Item Description' },
        { id: 'model', content: 'Model Name' },
        { id: 'manufacturer', content: 'Manufacturer' },
        { id: 'numeric_id', content: 'Numeric ID' },
        { id: 'alphanumeric_id', content: 'Alphanumeric ID' },
        { id: 'custom_id_1', content: 'Custom ID1' },
        { id: 'custom_id_2', content: 'Custom ID2' },
        { id: 'catalog', content: 'Catalog #' },
        { id: 'govt_id', content: 'Govt. ID' },
        { id: 'alt_id', content: 'Alt ID' },
    ],
    columns: {
        'left': { id: 'left', title: 'Left', taskIds: ['category', 'subcategory', 'description', 'model', 'manufacturer'] },
        'right': { id: 'right', title: 'Right', taskIds: ['numeric_id', 'alphanumeric_id', 'custom_id_1', 'custom_id_2'] },
        'unused': { id: 'unused', title: 'Unused', taskIds: ['catalog', 'govt_id', 'alt_id'] },
    },
};

export const locationIdLayout = {
    tasks: [
        { id: 'category', content: 'Category' },
        { id: 'subcategory', content: 'Subcategory' },
        { id: 'description', content: 'Item Description' },
        { id: 'model', content: 'Model Name' },
        { id: 'manufacturer', content: 'Manufacturer' },
        { id: 'numeric_id', content: 'Numeric ID' },
        { id: 'alphanumeric_id', content: 'Alphanumeric ID' },
        { id: 'custom_id_1', content: 'Custom ID1' },
        { id: 'custom_id_2', content: 'Custom ID2' },
        { id: 'catalog', content: 'Catalog #' },
        { id: 'govt_id', content: 'Govt. ID' },
        { id: 'alt_id', content: 'Alt ID' },
    ],
    columns: {
        'left': { id: 'left', title: 'Left', taskIds: ['category', 'subcategory', 'description', 'model', 'manufacturer', 'catalog'] },
        'right': { id: 'right', title: 'Right', taskIds: ['numeric_id', 'alphanumeric_id', 'custom_id_1', 'custom_id_2', 'govt_id', 'alt_id'] },
        'unused': { id: 'unused', title: 'Unused', taskIds: [] },
    },
};

export const headingsLayout = {
    tasks: [
        { id: 'sorted_by', content: 'Sorted By' },
        { id: 'organization_logo', content: 'Organization Logo' },
        { id: 'client_logo', content: 'Client Logo' },
        { id: 'report_name', content: 'Report Name' },
        { id: 'project_name', content: 'Project Name' },
        { id: 'project_address', content: 'Project Address' },
        { id: 'org_name', content: 'Organization Name' },
        { id: 'client_name', content: 'Client Name' }
    ],
    columns: {
        'unused': { id: 'unused', title: 'Unused', taskIds: ['sorted_by', 'project_address'] },
        'left': { id: 'left', title: 'Left', taskIds: ['org_name', 'client_name', 'project_name', 'report_name'] },
        'right': { id: 'right', title: 'Right', taskIds: ['organization_logo', 'client_logo'] },
    },
};

export const marginsLayout = {
    tasks: [
        { id: 'timestamp', content: 'TimeStamp' },
        { id: 'powered_by', content: 'Powered By' },
        { id: 'page_no', content: 'Page Number' }
    ],
    columns: {
        'unused': { id: 'unused', title: 'Unused', taskIds: [] },
        'top-left': { id: 'top-left', title: 'Top Left', taskIds: [] },
        'top-center': { id: 'top-center', title: 'Top Center', taskIds: [] },
        'top-right': { id: 'top-right', title: 'Top Right', taskIds: [] },
        'bottom-left': { id: 'bottom-left', title: 'Bottom Left', taskIds: ['timestamp', 'powered_by'] },
        'bottom-center': { id: 'bottom-center', title: 'Bottom Center', taskIds: [] },
        'bottom-right': { id: 'bottom-right', title: 'Bottom Right', taskIds: ['page_no'] },
    },
};

export const allColumns = {
    basic: [
        { title: 'Alt ID', field: 'alternate_id', display: 'Alt ID' },
        {
            title: 'Department Area Phase Name',
            field: 'department_phase_name',
            display: 'Department Area Phase Name'
        },
        {
            title: 'Department Area Phase Date',
            field: 'department_phase_date',
            display: 'Department Area Phase Date'
        },
        {
            title: 'Numeric ID',
            field: 'numeric_id',
            display: 'Numeric ID'
        },
        {
            title: 'Alphanumeric ID',
            field: 'alpha_numeric_id',
            display: 'Alphanumeric ID'
        },
        { title: 'Catalog #', field: 'catalog', display: 'Catalog #' },
        { title: 'Category', field: 'category', display: 'Category' },
        {
            title: 'SubCategory',
            field: 'subcategory',
            display: 'SubCategory'
        },
        {
            title: 'Custom ID1',
            field: 'custom_id_1',
            display: 'Custom ID1'
        },
        {
            title: 'Custom ID2',
            field: 'custom_id_2',
            display: 'Custom ID2'
        },
        {
            title: 'Description',
            field: 'description',
            display: 'Description'
        },
        {
            title: 'Alternate Description',
            field: 'alternate_description',
            display: 'Alternate Description'
        },
        {
            title: 'Item Area Phase Date',
            field: 'item_phase_date',
            display: 'Item Area Phase Date'
        },
        {
            title: 'Item Area Phase Name',
            field: 'item_phase_name',
            display: 'Item Area Phase Name'
        },
        { title: 'Govt ID', field: 'govt_id', display: 'Govt ID' },
        { title: 'Lead Time', field: 'lead_time', display: 'Lead Time' },
        {
            title: 'Long Description',
            field: 'long_description',
            display: 'Long Description'
        },
        {
            title: 'Manufacturer',
            field: 'manufacturer',
            display: 'Mfg'
        },
        { title: 'Model', field: 'model', display: 'Model' },
        { title: 'Need By', field: 'need_by_date', display: 'Need By' },
        {
            title: 'Organization',
            field: 'client_organization',
            display: 'Organization'
        },
        {
            title: 'Project Type',
            field: 'project_type',
            display: 'Project Type'
        },
        {
            title: 'Purchase By Date',
            field: 'purchase_by_date',
            display: 'Purchase By Date'
        },
        {
            title: 'Room Area Phase Date',
            field: 'room_phase_date',
            display: 'Room Area Phase Date'
        },
        {
            title: 'Room Area Phase Name',
            field: 'room_phase_name',
            display: 'Room Area Phase Name'
        },
        { title: 'Stage', field: 'stage', display: 'Stage' },
        { title: 'State', field: 'state', display: 'State' },
        { title: 'Status', field: 'status', display: 'Status' },
        {
            title: 'Product Type',
            field: 'product_type',
            display: 'Product Type'
        },
        { title: 'Vendor', field: 'vendor', display: 'Vendor' }
    ],
    financial: [
        { title: 'Additions', field: 'additions', display: 'Additions' },
        {
            title: 'Additions Tax',
            field: 'additions_tax',
            display: 'Additions Tax'
        },
        { title: 'Bid Group', field: 'bid_group', display: 'Bid Group' },
        { title: 'Budget', field: 'budget_name', display: 'Budget' },
        {
            title: 'Expanse Code',
            field: 'expanse_code',
            display: 'Expanse Code'
        },
        { title: 'Budget ID', field: 'budget_no', display: 'Budget ID' },
        {
            title: 'Budget Type',
            field: 'budget_type',
            display: 'Budget Type'
        },
        {
            title: 'Cost Center (Department)',
            field: 'dep_cost_center',
            display: 'Cost Center (Department)'
        },
        {
            title: 'Cost Center (Room)',
            field: 'room_cost_center',
            display: 'Cost Center (Room)'
        },
        { title: 'Deductions', field: 'deductions', display: 'Deductions' },
        { title: 'Discounts', field: 'discounts', display: 'Discounts' },
        {
            title: 'Division (Org)',
            field: 'division',
            display: 'Division (Org)'
        },
        { title: 'Fees', field: 'fees', display: 'Fees' },
        { title: 'Freight', field: 'freight', display: 'Freight' },
        {
            title: 'Funding Source',
            field: 'funding_source',
            display: 'Funding Src'
        },
        {
            title: 'Installation',
            field: 'installation',
            display: 'Installation'
        },
        { title: 'Item Qty', field: 'quantity', display: 'Item Qty' },
        {
            title: 'Price Type',
            field: 'product_price_type',
            display: 'Price Type'
        },
        {
            title: 'Project Funding Source',
            field: 'project_funding_source',
            display: 'Project Funding Source'
        },
        {
            title: 'Room Quantity',
            field: 'room_qty',
            display: 'Room Qty'
        },
        { title: 'Storage', field: 'storage', display: 'Storage' },
        { title: 'Subtotal', field: 'subtotal', display: 'Sub Total' },
        {
            title: 'Subtotal Tax',
            field: 'subtotal_tax',
            display: 'Subtotal Tax'
        },
        {
            title: 'Tax Exempt',
            field: 'is_tax_exempt',
            display: 'Tax Exempt'
        },
        { title: 'Tax Rate', field: 'tax_rate', display: 'Tax Rate' },
        {
            title: 'Total Cost',
            field: 'final_total',
            display: 'Total'
        },
        { title: 'Total Tax', field: 'total_tax', display: 'Total Tax' },
        {
            title: 'Total Extended Room-Item QTY',
            field: 'extended_item_quantity',
            display: 'Ext Item Qty'
        },
        {
            title: 'Total Extended Cost',
            field: 'extended_total',
            display: 'Ext Total'
        },
        { title: 'Trade In', field: 'trade_in', display: 'Trade In' },
        { title: 'Unit Cost', field: 'list_price', display: 'Price' }
    ],
    Responsibility: [
        { title: 'ADA', field: 'da_complient', display: 'ADA' },
        {
            title: 'Life Expectancy',
            field: 'life_expectancy',
            display: 'Life Expectancy'
        },
        {
            title: 'Anti-Microbial',
            field: 'antimicrobial',
            display: 'Anti-Microbial'
        },
        { title: 'Green', field: 'green', display: 'Green' },
        { title: 'Seismic', field: 'seismic', display: 'Seismic' },
        { title: 'Shielding', field: 'Shielding', display: 'Shielding' },
        {
            title: 'Arch Code',
            field: 'item_architectural_code',
            display: 'Arch Code'
        },
        {
            title: 'Furnish Responsibility',
            field: 'item_furnish',
            display: 'Furnish Resp'
        },
        {
            title: 'Install Responsibility',
            field: 'item_install',
            display: 'Install Resp'
        }
    ],
    Physical: [
        {
            title: 'Adjustable Depth',
            field: 'adjustable_depth',
            display: 'Adjust Depth'
        },
        {
            title: 'Adjustable Width',
            field: 'adjustable_width',
            display: 'Adjust Width'
        },
        {
            title: 'Adjustable Height',
            field: 'adjustable_height',
            display: 'Adjust Height'
        },
        {
            title: 'Back',
            field: 'clearance_back',
            display: 'Back'
        },
        {
            title: 'Front',
            field: 'clearance_front',
            display: 'Front'
        },
        {
            title: 'Left',
            field: 'clearance_left',
            display: 'Left'
        },
        {
            title: 'Right',
            field: 'clearance_right',
            display: 'Right'
        },
        {
            title: 'Bottom',
            field: 'clearance_bottom',
            display: 'Bottom'
        },
        { title: 'Top', field: 'clearance_top', display: 'Top' },
        { title: 'Width', field: 'width', display: 'Width' },
        { title: 'Height', field: 'height', display: 'Height' },
        { title: 'Depth', field: 'depth', display: 'Depth' },
        {
            title: 'Weight',
            field: 'max_weight',
            display: 'Weight'
        },
        {
            title: 'Ship Weight',
            field: 'ship_weight',
            display: 'Ship Weight'
        },
        { title: 'Mounting', field: 'mounting', display: 'Mounting' },
        {
            title: 'Architecturally Significant',
            field: 'item_architecturally_significant',
            display: 'Arch Sign'
        },
        {
            title: 'Spatially Significant',
            field: 'item_spatially_significant',
            display: 'Space Sign'
        },
        {
            title: 'Spatial Notes',
            field: 'spatial_notes',
            display: 'Spatial Notes'
        }
    ],
    CreatedBy: [
        { title: 'Created By', field: 'created_by', display: 'Created By' }
    ],
    Electrical: [
        {
            title: 'Voltage Type',
            field: 'voltageType',
            display: 'Voltage Type'
        },
        { title: 'Volts', field: 'volts', display: 'Volts' },
        { title: 'kVA', field: 'kva', display: 'kVA' },
        {
            title: 'Remote Transformer',
            field: 'remoteTrans',
            display: 'Remote Trans'
        },
        {
            title: 'Remote Switch/Controller',
            field: 'remoteSwitch',
            display: 'Remote Switch/Controller'
        },
        { title: 'Hertz', field: 'hertz', display: 'Hertz' },
        { title: 'Watts', field: 'watts', display: 'Watts' },
        { title: 'Amps', field: 'amps', display: 'Amps' },
        {
            title: 'Electrical Phase',
            field: 'electricalPhase',
            display: 'Phase'
        },
        { title: 'Plug Type', field: 'plugtype', display: 'Plug Type' },
        {
            title: 'Plug Detail',
            field: 'plugdetail',
            display: 'Plug Detail'
        },
        {
            title: 'Dedicated Circuit',
            field: 'dedicatedCircuit',
            display: 'Ded Cir'
        },
        {
            title: 'Emergency Power',
            field: 'emergencyPower',
            display: 'Emerg Pwr'
        },
        {
            title: 'Electrical Notes',
            field: 'electrical_notes',
            display: 'Elec Notes'
        }
    ],
    Mechanical: [
        {
            title: 'Dissipation Type',
            field: 'dissipationType',
            display: 'Diss Type'
        },
        {
            title: 'Heat Dissipation',
            field: 'heatDissipation',
            display: 'BTU/hr'
        },
        { title: 'Vent', field: 'vent', display: 'Vent' },
        { title: 'Vent Type', field: 'ventType', display: 'Vent Type' },
        {
            title: 'Mechanical Notes',
            field: 'mech_notes',
            display: 'Mech Notes'
        }
    ],
    Plumbing: [
        { title: 'Hot Water', field: 'hotWater', display: 'Hot Wtr' },
        { title: 'Cold Water', field: 'coldWater', display: 'Cold Wtr' },
        {
            title: 'Treated Water',
            field: 'treatedWater',
            display: 'Treat Wtr'
        },
        { title: 'Steam', field: 'steam', display: 'Steam' },
        {
            title: 'Vaccum Medical',
            field: 'vaccumMedical',
            display: 'Vaccum Medical'
        },
        {
            title: 'Vaccum Dental',
            field: 'vaccumDental',
            display: 'Vaccum Dental'
        },
        { title: 'Drain', field: 'drain', display: 'Drain' },
        {
            title: 'Medical Gas',
            field: 'medicalGas',
            display: 'MedGas'
        },
        {
            title: 'Drain Location',
            field: 'drainLocation',
            display: 'Drain Loc'
        },
        { title: 'Gas Type', field: 'gasType', display: 'Gas Type' },
        {
            title: 'Gas Location',
            field: 'gasLocation',
            display: 'Gas Loc'
        },
        {
            title: 'Plumbing/ Medgas Notes',
            field: 'plumbing_notes',
            display: 'Plbg/MGS Notes'
        }
    ],
    Thumbnail: [{ title: 'Thumbnail', field: 'thumbnail', display: 'Thumbnail' }],
    Technical: [
        {
            title: 'Tech Connection',
            field: 'isConnection',
            display: 'Tech Conn'
        },
        {
            title: 'Connection Types',
            field: 'connectionType',
            display: 'Conn Type'
        },
        { title: 'Network', field: 'network', display: 'Network' },
        {
            title: 'Technical Notes',
            field: 'tech_notes',
            display: 'Tech Notes'
        }
    ],
    Procurement: [
        { title: 'PA ID', field: 'action_id', display: 'PA ID' },
        { title: 'Requisition #', field: 'requisition_no', display: 'Reqiuisition #' },
        { title: 'Requisition Status', field: 'requisition_status', display: 'Reqiuisition Status' },
        { title: 'Bid #', field: 'bid_no', display: 'Bid #' },
        { title: 'Bid Status', field: 'bid_status', display: 'Bid Status' },
        { title: 'Bid Start Date', field: 'bid_start_date', display: 'Bid Start Date' },
        { title: 'Bid End Date', field: 'bid_end_date', display: 'Bid End Date' },
        { title: 'RFQ #', field: 'rfq_no', display: 'RFQ #' },
        { title: 'RFQ Status', field: 'rfq_status', display: 'RFQ Status' },
        { title: 'PO #', field: 'purchase_order_no', display: 'PO #' },
        { title: 'PO Status', field: 'purchase_order_status', display: 'PO Status' },
        { title: 'PO Issue Date', field: 'purchase_order_issue_date', display: 'PO Issue Date' },
        { title: 'PO Amount', field: 'purchase_order_amount', display: 'PO Amount' },
    ],
    'Action Dates': [
        { title: 'Purchased', field: 'purchased', display: 'Purchased' },
        { title: 'Shipped', field: 'shipped', display: 'Shipped' },
        { title: 'Received', field: 'received', display: 'Received' },
        { title: 'In Storage', field: 'instorage', display: 'In Storage' },
        { title: 'Damaged', field: 'damaged', display: 'Damaged' },
        { title: 'Returned', field: 'returned', display: 'Returned' },
        { title: 'Accepted', field: 'accepted', display: 'Accepted' },
        { title: 'Installation', field: 'installation', display: 'Installation' },
        { title: 'Tested', field: 'tested', display: 'Tested' },
        { title: 'Activated', field: 'activated', display: 'Activated' },
        { title: 'Biomed Inspected', field: 'biomed_inspected', display: 'Biomed Insp' },
        { title: 'Asset Tagged', field: 'asset_tagged', display: 'Asset Tagged' },
        { title: 'Training', field: 'training', display: 'Training' },
        { title: 'In Use', field: 'inuse', display: 'In Use' },
    ],
    Asset: [
        { title: 'Serial No', field: 'serial_no', display: 'Serial No' },
        { title: 'Asset Tag', field: 'asset_tag', display: 'Asset Tag' },
        { title: 'Biomed Tag', field: 'biomed_tag', display: 'Biomed Tag' },
        { title: 'Other Tag', field: 'other_tag', display: 'Other Tag' },
        { title: 'Condition', field: 'condition', display: 'Condition' },
        { title: 'Condition Notes', field: 'condition_notes', display: 'Condition Notes' }
    ],
    'Costing/Lifetime': [
        { title: 'Acquisiton Date', field: 'acquisiton_date', display: 'Acqn Date' },
        { title: 'End of useful Life Date', field: 'end_of_userful_life_date', display: 'End of useful life' },
        { title: 'Useful Life', field: 'useful_life', display: 'Useful life (Year)' },
        { title: 'Warrenty Start Date', field: 'warrenty_start_date', display: 'Wrnty Start Date' },
        { title: 'Warrenty End Date', field: 'warrenty_etart_date', display: 'Wrnty End Date' },
        { title: 'Warrenty Duration', field: 'warrenty_duration', display: 'Wrnty Duration (Year)' },
        { title: 'Depreciation', field: 'depreciation', display: 'Depreciation %' },
    ],
    Location: [
        { title: 'Level', field: 'level_name', display: 'Level' },
        { title: 'Level ID', field: 'level_no', display: 'Level ID' },
        { title: 'Building', field: 'building_name', display: 'Building' },
        {
            title: 'Building ID',
            field: 'building_no',
            display: 'Building ID'
        },
        {
            title: 'Building Type',
            field: 'building_type',
            display: 'Building Type'
        },
        {
            title: 'Department',
            field: 'department_name',
            display: 'Department'
        },
        {
            title: 'Department #',
            field: 'department_no',
            display: 'Department #'
        },
        { title: 'Room', field: 'room_name', display: 'Room' },
        { title: 'Room #', field: 'room_no', display: 'Room #' },
        { title: 'Room Area', field: 'room_area', display: 'Room Area' },
        { title: 'Total Room Area', field: 'total_area', display: 'Total Room Area' },
        {
            title: 'Room Signage',
            field: 'room_signage',
            display: 'Room Signage'
        },
        { title: 'Room Tags', field: 'tags', display: 'Room Tags' }
    ]
};

export const previewDataSheetColumns = [
    {
        id: 'col1',
        subHeaders: [
            { id: 'col1-sub1', title: "Level", field: 'level_name' },
        ]
    },
    {
        id: 'col2',
        subHeaders: [
            { id: 'col2-sub1', title: "Department", field: 'department_name' },
        ]
    },
    {
        id: 'col3',
        subHeaders: [
            { id: 'col3-sub1', title: "Room", field: 'room_name' },
        ]
    },
    {
        id: 'col4',
        subHeaders: [
            { id: 'col4-sub1', title: "Room #", field: 'room_no' },
        ]
    },
    {
        id: 'col5',
        subHeaders: [
            { id: 'col5-sub1', title: "Status", field: 'status' },
        ]
    },
    {
        id: 'col6',
        subHeaders: [
            { id: 'col6-sub1', title: "Item Qty", field: 'quantity' },
        ]
    }
];

export const previewDataSheetTableColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col2-sub2",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col4-sub1",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "id": "col5-sub1",
                "title": "Item Qty",
                "field": "quantity",
                "mainId": "col5"
            }
        ]
    }
];

export const previewItemDetailColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Room",
                "field": "room_name",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col6-sub3",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Funding Src",
                "field": "funding_source",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Budget",
                "field": "budget_name",
                "id": "col7-sub2",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col8-sub1",
                "mainId": "col8"
            },
            {
                "title": "Stage",
                "field": "stage",
                "id": "col8-sub2",
                "mainId": "col8"
            },
            {
                "title": "Need By",
                "field": "need_by_date",
                "id": "col8-sub3",
                "mainId": "col8"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Price",
                "field": "list_price",
                "id": "col9-sub1",
                "mainId": "col9"
            },
            {
                "title": "Subtotal",
                "field": "subtotal",
                "id": "col9-sub2",
                "mainId": "col9"
            },
            {
                "title": "Total",
                "field": "final_total",
                "id": "col9-sub3",
                "mainId": "col9"
            },
            {
                "title": "Ext Total",
                "field": "extended_total",
                "id": "col9-sub4",
                "mainId": "col9"
            }
        ]
    }
];

export const previewItemSpecColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col3-sub3",
                "mainId": "col3"
            },
            {
                "title": "Catalog #",
                "field": "catalog",
                "id": "col3-sub4",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Stage",
                "field": "stage",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Funding Src",
                "field": "funding_source",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Width",
                "field": "width",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Depth",
                "field": "depth",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Height",
                "field": "height",
                "id": "col6-sub3",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Mounting",
                "field": "mounting",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Weight",
                "field": "max_weight",
                "id": "col7-sub2",
                "mainId": "col7"
            },
            {
                "title": "Arch Sign",
                "field": "item_architecturally_significant",
                "id": "col7-sub3",
                "mainId": "col7"
            },
            {
                "title": "Space Sign",
                "field": "item_spatially_significant",
                "id": "col7-sub4",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Volts",
                "field": "volts",
                "id": "col8-sub1",
                "mainId": "col8"
            },
            {
                "title": "Amps",
                "field": "amps",
                "id": "col8-sub2",
                "mainId": "col8"
            },
            {
                "title": "Watts",
                "field": "watts",
                "id": "col8-sub3",
                "mainId": "col8"
            },
            {
                "title": "kVA",
                "field": "kva",
                "id": "col8-sub4",
                "mainId": "col8"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Phase",
                "field": "electricalPhase",
                "id": "col9-sub1",
                "mainId": "col9"
            },
            {
                "title": "Plug Type",
                "field": "plugtype",
                "id": "col9-sub2",
                "mainId": "col9"
            },
            {
                "title": "Ded Cir",
                "field": "dedicatedCircuit",
                "id": "col9-sub3",
                "mainId": "col9"
            },
            {
                "title": "Emerg Pwr",
                "field": "emergencyPower",
                "id": "col9-sub4",
                "mainId": "col9"
            }
        ]
    },
    {
        "id": "col10",
        "subHeaders": [
            {
                "title": "Tech Conn",
                "field": "isConnection",
                "id": "col10-sub1",
                "mainId": "col10"
            },
            {
                "title": "Conn Type",
                "field": "connectionType",
                "id": "col10-sub2",
                "mainId": "col10"
            }
        ]
    },
    {
        "id": "col11",
        "subHeaders": [
            {
                "title": "Cold Wtr",
                "field": "coldWater",
                "id": "col11-sub1",
                "mainId": "col11"
            },
            {
                "title": "Hot Wtr",
                "field": "hotWater",
                "id": "col11-sub2",
                "mainId": "col11"
            },
            {
                "title": "Treat Wtr",
                "field": "treatedWater",
                "id": "col11-sub3",
                "mainId": "col11"
            }
        ]
    },
    {
        "id": "col12",
        "subHeaders": [
            {
                "title": "Steam",
                "field": "steam",
                "id": "col12-sub1",
                "mainId": "col12"
            },
            {
                "title": "Drain",
                "field": "drain",
                "id": "col12-sub2",
                "mainId": "col12"
            },
            {
                "title": "Drain Loc",
                "field": "drainLocation",
                "id": "col12-sub3",
                "mainId": "col12"
            }
        ]
    },
    {
        "id": "col13",
        "subHeaders": [
            {
                "title": "MedGas",
                "field": "medicalGas",
                "id": "col13-sub1",
                "mainId": "col13"
            },
            {
                "title": "Gas Type",
                "field": "gasType",
                "id": "col13-sub2",
                "mainId": "col13"
            },
            {
                "title": "Gas Loc",
                "field": "gasLocation",
                "id": "col13-sub3",
                "mainId": "col13"
            }
        ]
    },
    {
        "id": "col14",
        "subHeaders": [
            {
                "title": "Vent",
                "field": "vent",
                "id": "col14-sub1",
                "mainId": "col14"
            },
            {
                "title": "Vent Type",
                "field": "ventType",
                "id": "col14-sub2",
                "mainId": "col14"
            },
            {
                "title": "BTU/hr",
                "field": "heatDissipation",
                "id": "col14-sub3",
                "mainId": "col14"
            }
        ]
    },
    {
        "id": "col15",
        "subHeaders": [
            {
                "title": "Elec Notes",
                "field": "electrical_notes",
                "id": "col15-sub1",
                "mainId": "col15"
            },
            {
                "title": "Tech Notes",
                "field": "tech_notes",
                "id": "col15-sub2",
                "mainId": "col15"
            },
            {
                "title": "Plbg/MGS Notes",
                "field": "plumbing_notes",
                "id": "col15-sub3",
                "mainId": "col15"
            },
            {
                "title": "Mech Notes",
                "field": "mech_notes",
                "id": "col15-sub4",
                "mainId": "col15"
            }
        ]
    }
];

export const previewItemSummary = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col2-sub1",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col3-sub2",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Funding Src",
                "field": "funding_source",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Budget",
                "field": "budget_name",
                "id": "col6-sub2",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Stage",
                "field": "stage",
                "id": "col7-sub2",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col8-sub1",
                "mainId": "col8"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col9-sub1",
                "mainId": "col9"
            },
            {
                "title": "Price",
                "field": "list_price",
                "id": "col9-sub2",
                "mainId": "col9"
            }
        ]
    },
    {
        "id": "col10",
        "subHeaders": [
            {
                "title": "Total",
                "field": "final_total",
                "id": "col10-sub1",
                "mainId": "col10"
            },
            {
                "title": "Ext Total",
                "field": "extended_total",
                "id": "col10-sub2",
                "mainId": "col10"
            }
        ]
    }
];

export const previewItemLocColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "id": "col1-sub1",
                "title": "Level",
                "field": "level_name",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "id": "col2-sub1",
                "title": "Department",
                "field": "department_name",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "id": "col3-sub1",
                "title": "Room",
                "field": "room_name",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "id": "col4-sub1",
                "title": "Room #",
                "field": "room_no",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "id": "col5-sub1",
                "title": "Status",
                "field": "status",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col6-sub2",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col7-sub2",
                "mainId": "col7"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col7-sub3",
                "mainId": "col7"
            }
        ]
    }
];

export const sortingFields = [
    { value: 'sku_no', title: 'Numeric ID' },
    { value: 'prefix', title: 'Alphaneumaric ID' },
    { value: 'description', title: 'Description' },
    { value: 'category_name', title: 'Category/Subcategory' },
    { value: 'inventory_id', title: 'Inventory ID' },
    { value: 'custom_id_1', title: 'Custom ID1' },
    { value: 'custom_id_2', title: 'Custom ID2' },
    { value: 'action_id', title: 'Requisition ID' },
    { value: 'action_no', title: 'Requisition #' },
    { value: 'pa_id', title: 'PA ID' },
    { value: 'vender_id', title: 'Vendor' }
]

export const groupingFields = [
    { value: 'department_id', title: 'Department' },
    { value: 'category_id', title: 'Category' },
    { value: 'sub_category_id', title: 'Sub Category' },
    { value: 'description', title: 'Description' },
    { value: 'numeric_id', title: 'Numeric ID' },
    { value: 'alpha_numeric_id', title: 'Alphaneumeric ID' },
    { value: 'manufacturer_id', title: 'Manufacturer' },
    { value: 'vender_id', title: 'Vendor' }
]

export const prevColRoomListPrice = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Room",
                "field": "room_name",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "Total",
                "field": "final_total",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Ext Total",
                "field": "extended_total",
                "id": "col3-sub2",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Room Area",
                "field": "room_area",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Total Room Area",
                "field": "total_area",
                "id": "col4-sub2",
                "mainId": "col4"
            }
        ]
    }
]

export const prevColRoomListWithoutPrice = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Room",
                "field": "room_name",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col2-sub2",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col3-sub1",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Room Area",
                "field": "room_area",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Total Room Area",
                "field": "total_area",
                "id": "col4-sub2",
                "mainId": "col4"
            }
        ]
    }
]

export const prevColRoomDetailWithPrice = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col2-sub1",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col9-sub1",
                "mainId": "col9"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col6-sub3",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Price",
                "field": "list_price",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Sub Total",
                "field": "subtotal",
                "id": "col7-sub2",
                "mainId": "col7"
            },
            {
                "title": "Total",
                "field": "final_total",
                "id": "col7-sub3",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Ext Total",
                "field": "extended_total",
                "id": "col8-sub1",
                "mainId": "col8"
            }
        ]
    }
]

export const prevColRoomDetailWithoutPrice = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col2-sub1",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col7-sub1",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col6-sub3",
                "mainId": "col6"
            }
        ]
    }
];

export const previewProjectItemSummColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col3-sub3",
                "mainId": "col3"
            },
            {
                "title": "Catalog #",
                "field": "catalog",
                "id": "col3-sub4",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Stage",
                "field": "stage",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Funding Src",
                "field": "funding_source",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Width",
                "field": "width",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Depth",
                "field": "depth",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Height",
                "field": "height",
                "id": "col6-sub3",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Mounting",
                "field": "mounting",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Weight",
                "field": "max_weight",
                "id": "col7-sub2",
                "mainId": "col7"
            },
            {
                "title": "Arch Sign",
                "field": "item_architecturally_significant",
                "id": "col7-sub3",
                "mainId": "col7"
            },
            {
                "title": "Space Sign",
                "field": "item_spatially_significant",
                "id": "col7-sub4",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Volts",
                "field": "volts",
                "id": "col8-sub1",
                "mainId": "col8"
            },
            {
                "title": "Amps",
                "field": "amps",
                "id": "col8-sub2",
                "mainId": "col8"
            },
            {
                "title": "Watts",
                "field": "watts",
                "id": "col8-sub3",
                "mainId": "col8"
            },
            {
                "title": "kVA",
                "field": "kva",
                "id": "col8-sub4",
                "mainId": "col8"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Phase",
                "field": "electricalPhase",
                "id": "col9-sub1",
                "mainId": "col9"
            },
            {
                "title": "Plug Type",
                "field": "plugtype",
                "id": "col9-sub2",
                "mainId": "col9"
            },
            {
                "title": "Ded Cir",
                "field": "dedicatedCircuit",
                "id": "col9-sub3",
                "mainId": "col9"
            },
            {
                "title": "Emerg Pwr",
                "field": "emergencyPower",
                "id": "col9-sub4",
                "mainId": "col9"
            }
        ]
    },
    {
        "id": "col10",
        "subHeaders": [
            {
                "title": "Tech Conn",
                "field": "isConnection",
                "id": "col10-sub1",
                "mainId": "col10"
            },
            {
                "title": "Conn Type",
                "field": "connectionType",
                "id": "col10-sub2",
                "mainId": "col10"
            }
        ]
    },
    {
        "id": "col11",
        "subHeaders": [
            {
                "title": "Cold Wtr",
                "field": "coldWater",
                "id": "col11-sub1",
                "mainId": "col11"
            },
            {
                "title": "Hot Wtr",
                "field": "hotWater",
                "id": "col11-sub2",
                "mainId": "col11"
            },
            {
                "title": "Treat Wtr",
                "field": "treatedWater",
                "id": "col11-sub3",
                "mainId": "col11"
            }
        ]
    },
    {
        "id": "col12",
        "subHeaders": [
            {
                "title": "Steam",
                "field": "steam",
                "id": "col12-sub1",
                "mainId": "col12"
            },
            {
                "title": "Drain",
                "field": "drain",
                "id": "col12-sub2",
                "mainId": "col12"
            },
            {
                "title": "Drain Loc",
                "field": "drainLocation",
                "id": "col12-sub3",
                "mainId": "col12"
            }
        ]
    },
    {
        "id": "col13",
        "subHeaders": [
            {
                "title": "MedGas",
                "field": "medicalGas",
                "id": "col13-sub1",
                "mainId": "col13"
            },
            {
                "title": "Gas Type",
                "field": "gasType",
                "id": "col13-sub2",
                "mainId": "col13"
            },
            {
                "title": "Gas Loc",
                "field": "gasLocation",
                "id": "col13-sub3",
                "mainId": "col13"
            }
        ]
    },
    {
        "id": "col14",
        "subHeaders": [
            {
                "title": "Vent",
                "field": "vent",
                "id": "col14-sub1",
                "mainId": "col14"
            },
            {
                "title": "Vent Type",
                "field": "ventType",
                "id": "col14-sub2",
                "mainId": "col14"
            },
            {
                "title": "BTU/hr",
                "field": "heatDissipation",
                "id": "col14-sub3",
                "mainId": "col14"
            }
        ]
    },
    {
        "id": "col15",
        "subHeaders": [
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col15-sub1",
                "mainId": "col15"
            },
            {
                "title": "Price",
                "field": "list_price",
                "id": "col15-sub2",
                "mainId": "col15"
            },
            {
                "title": "Ext Total",
                "field": "extended_total",
                "id": "col15-sub3",
                "mainId": "col15"
            }
        ]
    }
];

export const previewProjectCeritifiColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col3-sub3",
                "mainId": "col3"
            },
            {
                "title": "Catalog #",
                "field": "catalog",
                "id": "col3-sub4",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col4-sub1",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Room",
                "field": "room_name",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col6-sub2",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Price",
                "field": "list_price",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Ext Total",
                "field": "extended_total",
                "id": "col7-sub2",
                "mainId": "col7"
            }
        ]
    }
];

export const previewRoomDataDetailColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    }
]

export const previewRoomDataSpecColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col2-sub3",
                "mainId": "col2"
            },
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col2-sub4",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mounting",
                "field": "mounting",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Width",
                "field": "width",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Depth",
                "field": "depth",
                "id": "col3-sub3",
                "mainId": "col3"
            },
            {
                "title": "Height",
                "field": "height",
                "id": "col3-sub4",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Volts",
                "field": "volts",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Amps",
                "field": "amps",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Watts",
                "field": "watts",
                "id": "col4-sub3",
                "mainId": "col4"
            },
            {
                "title": "Phase",
                "field": "electricalPhase",
                "id": "col4-sub4",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Ded Cir",
                "field": "dedicatedCircuit",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Emerg Pwr",
                "field": "emergencyPower",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Tech Conn",
                "field": "isConnection",
                "id": "col5-sub3",
                "mainId": "col5"
            },
            {
                "title": "Conn Type",
                "field": "connectionType",
                "id": "col5-sub4",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Cold Wtr",
                "field": "coldWater",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Hot Wtr",
                "field": "hotWater",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Treat Wtr",
                "field": "treatedWater",
                "id": "col6-sub3",
                "mainId": "col6"
            },
            {
                "title": "Steam",
                "field": "steam",
                "id": "col6-sub4",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Drain",
                "field": "drain",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "MedGas",
                "field": "medicalGas",
                "id": "col7-sub2",
                "mainId": "col7"
            },
            {
                "title": "Vent",
                "field": "vent",
                "id": "col7-sub3",
                "mainId": "col7"
            },
            {
                "title": "BTU/hr",
                "field": "heatDissipation",
                "id": "col7-sub4",
                "mainId": "col7"
            }
        ]
    }
]

export const previewProcurementColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Description",
                "field": "description",
                "id": "col1-sub1",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col2-sub1",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub1",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col4-sub1",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Price",
                "field": "list_price",
                "id": "col5-sub1",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Total",
                "field": "final_total",
                "id": "col7-sub1",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Ext Total",
                "field": "extended_total",
                "id": "col6-sub1",
                "mainId": "col6"
            }
        ]
    }
];

export const previewPOActionColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col2-sub1",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Description",
                "field": "description",
                "id": "col3-sub1",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col4-sub1",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col5-sub1",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Model",
                "field": "model",
                "id": "col6-sub1",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col7-sub1",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Room",
                "field": "room_name",
                "id": "col8-sub1",
                "mainId": "col8"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col9-sub1",
                "mainId": "col9"
            }
        ]
    },
    {
        "id": "col10",
        "subHeaders": [
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col10-sub1",
                "mainId": "col10"
            }
        ]
    },
    {
        "id": "col11",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col11-sub1",
                "mainId": "col11"
            }
        ]
    },
    {
        "id": "col12",
        "subHeaders": [
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col12-sub1",
                "mainId": "col12"
            }
        ]
    },
    {
        "id": "col13",
        "subHeaders": [
            {
                "title": "PA ID",
                "field": "action_id",
                "id": "col13-sub1",
                "mainId": "col13"
            }
        ]
    },
    {
        "id": "col14",
        "subHeaders": [
            {
                "title": "Reqiuisition #",
                "field": "requisition_no",
                "id": "col14-sub1",
                "mainId": "col14"
            }
        ]
    },
    {
        "id": "col15",
        "subHeaders": [
            {
                "title": "Reqiuisition Status",
                "field": "requisition_status",
                "id": "col15-sub1",
                "mainId": "col15"
            }
        ]
    },
    {
        "id": "col16",
        "subHeaders": [
            {
                "title": "Bid #",
                "field": "bid_no",
                "id": "col16-sub1",
                "mainId": "col16"
            }
        ]
    },
    {
        "id": "col17",
        "subHeaders": [
            {
                "title": "Bid Status",
                "field": "bid_status",
                "id": "col17-sub1",
                "mainId": "col17"
            }
        ]
    },
    {
        "id": "col18",
        "subHeaders": [
            {
                "title": "Bid Start Date",
                "field": "bid_start_date",
                "id": "col18-sub1",
                "mainId": "col18"
            }
        ]
    },
    {
        "id": "col19",
        "subHeaders": [
            {
                "title": "Bid End Date",
                "field": "bid_end_date",
                "id": "col19-sub1",
                "mainId": "col19"
            }
        ]
    },
    {
        "id": "col20",
        "subHeaders": [
            {
                "title": "RFQ #",
                "field": "rfq_no",
                "id": "col20-sub1",
                "mainId": "col20"
            }
        ]
    },
    {
        "id": "col21",
        "subHeaders": [
            {
                "title": "RFQ Status",
                "field": "rfq_status",
                "id": "col21-sub1",
                "mainId": "col21"
            }
        ]
    },
    {
        "id": "col22",
        "subHeaders": [
            {
                "title": "PO #",
                "field": "purchase_order_no",
                "id": "col22-sub1",
                "mainId": "col22"
            }
        ]
    },
    {
        "id": "col23",
        "subHeaders": [
            {
                "title": "PO Status",
                "field": "purchase_order_status",
                "id": "col23-sub1",
                "mainId": "col23"
            }
        ]
    },
    {
        "id": "col24",
        "subHeaders": [
            {
                "title": "PO Issue Date",
                "field": "purchase_order_issue_date",
                "id": "col24-sub1",
                "mainId": "col24"
            }
        ]
    },
    {
        "id": "col25",
        "subHeaders": [
            {
                "title": "PO Amount",
                "field": "purchase_order_amount",
                "id": "col25-sub1",
                "mainId": "col25"
            }
        ]
    }
];

export const previewProcurementScheduleColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Room",
                "field": "room_name",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Purchased",
                "field": "purchased",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Shipped",
                "field": "shipped",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Received",
                "field": "received",
                "id": "col6-sub3",
                "mainId": "col6"
            },
            {
                "title": "In Storage",
                "field": "instorage",
                "id": "col6-sub4",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Damaged",
                "field": "damaged",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Returned",
                "field": "returned",
                "id": "col7-sub2",
                "mainId": "col7"
            },
            {
                "title": "Accepted",
                "field": "accepted",
                "id": "col7-sub3",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Installation",
                "field": "installation",
                "id": "col8-sub1",
                "mainId": "col8"
            },
            {
                "title": "Tested",
                "field": "tested",
                "id": "col8-sub2",
                "mainId": "col8"
            },
            {
                "title": "Activated",
                "field": "activated",
                "id": "col8-sub3",
                "mainId": "col8"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Biomed Insp",
                "field": "biomed_inspected",
                "id": "col9-sub1",
                "mainId": "col9"
            },
            {
                "title": "Asset Tagged",
                "field": "asset_tagged",
                "id": "col9-sub2",
                "mainId": "col9"
            }
        ]
    },
    {
        "id": "col10",
        "subHeaders": [
            {
                "title": "Training",
                "field": "training",
                "id": "col10-sub1",
                "mainId": "col10"
            },
            {
                "title": "In Use",
                "field": "inuse",
                "id": "col10-sub2",
                "mainId": "col10"
            }
        ]
    },
    {
        "id": "col11",
        "subHeaders": [
            {
                "title": "Serial No",
                "field": "serial_no",
                "id": "col11-sub1",
                "mainId": "col11"
            },
            {
                "title": "Asset Tag",
                "field": "asset_tag",
                "id": "col11-sub2",
                "mainId": "col11"
            },
            {
                "title": "Biomed Tag",
                "field": "biomed_tag",
                "id": "col11-sub3",
                "mainId": "col11"
            },
            {
                "title": "Other Tag",
                "field": "other_tag",
                "id": "col11-sub4",
                "mainId": "col11"
            }
        ]
    },
    {
        "id": "col12",
        "subHeaders": [
            {
                "title": "Acqn Date",
                "field": "acquisiton_date",
                "id": "col12-sub1",
                "mainId": "col12"
            },
            {
                "title": "End of useful life",
                "field": "end_of_userful_life_date",
                "id": "col12-sub2",
                "mainId": "col12"
            },
            {
                "title": "Useful life (Year)",
                "field": "useful_life",
                "id": "col12-sub3",
                "mainId": "col12"
            }
        ]
    },
    {
        "id": "col13",
        "subHeaders": [
            {
                "title": "Wrnty Start Date",
                "field": "warrenty_start_date",
                "id": "col13-sub1",
                "mainId": "col13"
            },
            {
                "title": "Wrnty End Date",
                "field": "warrenty_etart_date",
                "id": "col13-sub2",
                "mainId": "col13"
            },
            {
                "title": "Wrnty Duration (Year)",
                "field": "warrenty_duration",
                "id": "col13-sub3",
                "mainId": "col13"
            }
        ]
    },
    {
        "id": "col14",
        "subHeaders": [
            {
                "title": "Depreciation %",
                "field": "depreciation",
                "id": "col14-sub1",
                "mainId": "col14"
            }
        ]
    },
    {
        "id": "col15",
        "subHeaders": [
            {
                "title": "Condition",
                "field": "condition",
                "id": "col15-sub1",
                "mainId": "col15"
            },
            {
                "title": "Condition Notes",
                "field": "condition_notes",
                "id": "col15-sub2",
                "mainId": "col15"
            }
        ]
    }
];

export const previewPoSummaryColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Room",
                "field": "room_name",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Status",
                "field": "status",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Furnish Resp",
                "field": "item_furnish",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Install Resp",
                "field": "item_install",
                "id": "col6-sub3",
                "mainId": "col6"
            },
            {
                "title": "Arch Code",
                "field": "item_architectural_code",
                "id": "col6-sub4",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col7",
        "subHeaders": [
            {
                "title": "Funding Src",
                "field": "funding_source",
                "id": "col7-sub1",
                "mainId": "col7"
            },
            {
                "title": "Cost Center (Room)",
                "field": "room_cost_center",
                "id": "col7-sub2",
                "mainId": "col7"
            },
            {
                "title": "Budget",
                "field": "budget_name",
                "id": "col7-sub3",
                "mainId": "col7"
            },
            {
                "title": "Price Type",
                "field": "product_price_type",
                "id": "col7-sub4",
                "mainId": "col7"
            }
        ]
    },
    {
        "id": "col8",
        "subHeaders": [
            {
                "title": "Reqiuisition #",
                "field": "requisition_no",
                "id": "col8-sub1",
                "mainId": "col8"
            },
            {
                "title": "PO #",
                "field": "purchase_order_no",
                "id": "col8-sub2",
                "mainId": "col8"
            },
            {
                "title": "PO Issue Date",
                "field": "purchase_order_issue_date",
                "id": "col8-sub3",
                "mainId": "col8"
            }
        ]
    },
    {
        "id": "col9",
        "subHeaders": [
            {
                "title": "Additions",
                "field": "planned_additions",
                "id": "col9-sub1",
                "mainId": "col9"
            },
            {
                "title": "Deductions",
                "field": "planned_deductions",
                "id": "col9-sub2",
                "mainId": "col9"
            }
        ]
    },
    {
        "id": "col10",
        "subHeaders": [
            {
                "title": "Unit Cost",
                "field": "planned_unit_cost",
                "id": "col10-sub1",
                "mainId": "col10"
            },
            {
                "title": "Subtotal",
                "field": "planned_subtotal",
                "id": "col10-sub2",
                "mainId": "col10"
            },
            {
                "title": "Total",
                "field": "planned_total",
                "id": "col10-sub3",
                "mainId": "col10"
            },
            {
                "title": "Ext. Total",
                "field": "planned_extended_total",
                "id": "col10-sub4",
                "mainId": "col10"
            }
        ]
    },
    {
        "id": "col11",
        "subHeaders": [
            {
                "title": "Additions",
                "field": "po_additions",
                "id": "col11-sub1",
                "mainId": "col11"
            },
            {
                "title": "Deductions",
                "field": "po_deductions",
                "id": "col11-sub2",
                "mainId": "col11"
            }
        ]
    },
    {
        "id": "col12",
        "subHeaders": [
            {
                "title": "Unit Cost",
                "field": "po_unit_cost",
                "id": "col12-sub1",
                "mainId": "col12"
            },
            {
                "title": "Subtotal",
                "field": "po_subtotal",
                "id": "col12-sub2",
                "mainId": "col12"
            },
            {
                "title": "Total",
                "field": "po_total",
                "id": "col12-sub3",
                "mainId": "col12"
            },
            {
                "title": "Ext. Total",
                "field": "po_extended_total",
                "id": "col12-sub4",
                "mainId": "col12"
            }
        ]
    },
    {
        "id": "col13",
        "subHeaders": [
            {
                "title": "Additions",
                "field": "variance_additions",
                "id": "col13-sub1",
                "mainId": "col13"
            },
            {
                "title": "Deductions",
                "field": "variance_deductions",
                "id": "col13-sub2",
                "mainId": "col13"
            }
        ]
    },
    {
        "id": "col14",
        "subHeaders": [
            {
                "title": "Unit Cost",
                "field": "variance_unit_cost",
                "id": "col14-sub1",
                "mainId": "col14"
            },
            {
                "title": "Subtotal",
                "field": "variance_subtotal",
                "id": "col14-sub2",
                "mainId": "col14"
            },
            {
                "title": "Total",
                "field": "variance_total",
                "id": "col14-sub3",
                "mainId": "col14"
            },
            {
                "title": "Ext. Total",
                "field": "variance_extended_total",
                "id": "col14-sub4",
                "mainId": "col14"
            }
        ]
    }
];

export const previewPointIntimeColumns = [
    {
        "id": "col1",
        "subHeaders": [
            {
                "title": "Numeric ID",
                "field": "numeric_id",
                "id": "col1-sub1",
                "mainId": "col1"
            },
            {
                "title": "Alphanumeric ID",
                "field": "alpha_numeric_id",
                "id": "col1-sub2",
                "mainId": "col1"
            },
            {
                "title": "Alt ID",
                "field": "alternate_id",
                "id": "col1-sub3",
                "mainId": "col1"
            }
        ]
    },
    {
        "id": "col2",
        "subHeaders": [
            {
                "title": "Category",
                "field": "category",
                "id": "col2-sub1",
                "mainId": "col2"
            },
            {
                "title": "SubCategory",
                "field": "subcategory",
                "id": "col2-sub2",
                "mainId": "col2"
            },
            {
                "title": "Description",
                "field": "description",
                "id": "col2-sub3",
                "mainId": "col2"
            }
        ]
    },
    {
        "id": "col3",
        "subHeaders": [
            {
                "title": "Mfg",
                "field": "manufacturer",
                "id": "col3-sub1",
                "mainId": "col3"
            },
            {
                "title": "Model",
                "field": "model",
                "id": "col3-sub2",
                "mainId": "col3"
            },
            {
                "title": "Vendor",
                "field": "vendor",
                "id": "col3-sub3",
                "mainId": "col3"
            }
        ]
    },
    {
        "id": "col4",
        "subHeaders": [
            {
                "title": "Department",
                "field": "department_name",
                "id": "col4-sub1",
                "mainId": "col4"
            },
            {
                "title": "Room",
                "field": "room_name",
                "id": "col4-sub2",
                "mainId": "col4"
            },
            {
                "title": "Room #",
                "field": "room_no",
                "id": "col4-sub3",
                "mainId": "col4"
            }
        ]
    },
    {
        "id": "col6",
        "subHeaders": [
            {
                "title": "Funding Src",
                "field": "funding_source",
                "id": "col6-sub1",
                "mainId": "col6"
            },
            {
                "title": "Cost Center (Room)",
                "field": "room_cost_center",
                "id": "col6-sub2",
                "mainId": "col6"
            },
            {
                "title": "Budget",
                "field": "budget_name",
                "id": "col6-sub3",
                "mainId": "col6"
            }
        ]
    },
    {
        "id": "col5",
        "subHeaders": [
            {
                "title": "Item Qty",
                "field": "quantity",
                "id": "col5-sub1",
                "mainId": "col5"
            },
            {
                "title": "Room Qty",
                "field": "room_qty",
                "id": "col5-sub2",
                "mainId": "col5"
            },
            {
                "title": "Ext Item Qty",
                "field": "extended_item_quantity",
                "id": "col5-sub3",
                "mainId": "col5"
            }
        ]
    }
];

export const gropuing = ['department_id', 'room_id', 'room_no']

export const defaultFinishes = [{
    id: 1, label: 'Floor Finish', value: '', default: true
}, {
    id: 2, label: 'Wall Finish', value: '', default: true
}, {
    id: 3, label: 'Window / Observation', value: '', default: true
}, {
    id: 4, label: 'Ceiling finish', value: '', default: true
}, {
    id: 5, label: 'Ceiling Height', value: '', default: true
}, {
    id: 6, label: 'Wall Protection', value: '', default: true
}];

export const defaultMileWorks = [{
    id: 1, label: 'Millwork Type', value: '', default: true
}, {
    id: 2, label: 'Notes', value: '', default: true
}];

export const defaultDoors = {
    'Door_1': [
        { id: 1, label: 'Door No', value: '', default: true },
        { id: 2, label: 'Door Size', value: '', default: true },
        { id: 3, label: 'Door Profile', value: '', default: true },
        { id: 4, label: 'Door Material', value: '', default: true },
        { id: 5, label: 'Frame Material', value: '', default: true }
    ]
};

export const defaultServices = [
    { id: 1, label: 'TV / Entertainment system', category: 'IT / Communications', qty: '', remarks: '', default: true },
    { id: 2, label: 'Voice / Data outlet', category: 'IT / Communications', qty: '', remarks: '', default: true },
    { id: 3, label: 'Airconditioning / Diffusers', category: 'Mechanical / HVAC', qty: '', remarks: '', default: true },
    { id: 4, label: 'Return', category: 'Mechanical / HVAC', qty: '', remarks: '', default: true },
    { id: 5, label: 'Laminar Airflow', category: 'Mechanical / HVAC', qty: '', remarks: '', default: true },
    { id: 6, label: 'Lighting : Decorative', category: 'Electrical / Lighting', qty: '', remarks: '', default: true },
    { id: 7, label: 'Lighting : Downlights', category: 'Electrical / Lighting', qty: '', remarks: '', default: true },
    { id: 8, label: 'Lighting : Night Lights', category: 'Electrical / Lighting', qty: '', remarks: '', default: true },
    { id: 9, label: 'Lighting : Reading', category: 'Electrical / Lighting', qty: '', remarks: '', default: true },
    { id: 10, label: 'Electrical Outlet : Normal', category: 'Electrical / Power', qty: '', remarks: '', default: true },
    { id: 11, label: 'Electrical Outlet : Emergency', category: 'Electrical / Power', qty: '', remarks: '', default: true },
    { id: 12, label: 'Electrical Outlet : Special', category: 'Electrical / Power', qty: '', remarks: '', default: true },
    { id: 13, label: 'Hardwire Connection', category: 'Electrical / Power', qty: '', remarks: '', default: true },
    { id: 14, label: 'Medical Air', category: 'MedGas', qty: '', remarks: '', default: true },
    { id: 15, label: 'Oxygen', category: 'MedGas', qty: '', remarks: '', default: true },
    { id: 16, label: 'Vaccuum', category: 'MedGas', qty: '', remarks: '', default: true },
    { id: 17, label: 'Nurse Call', category: 'IT / Communications', qty: '', remarks: '', default: true },
    { id: 18, label: 'Water Connection', category: 'Mechanical / Plumbing', qty: '', remarks: '', default: true },
    { id: 19, label: 'Drain', category: 'Mechanical / Plumbing', qty: '', remarks: '', default: true },
    { id: 20, label: 'Drain location', category: 'Mechanical / Plumbing', qty: '', remarks: '', default: true }
];

export const ProjectFields = [
    {
        "field": "Inventory ID",
        "description": "Reset clears all item IDs",
    },
    {
        "field": "Item Notes",
        "description": "Reset clears all item notes"
    },
    {
        "field": "Price",
        "description": "Reset restores all prices to catalog price",
    },
    {
        "field": "Product",
        "description": "Reset sets all products to Unspecified",
    },
    {
        "field": "Room Notes",
        "description": "Reset clears all room notes"
    },
    {
        "field": "Room #",
        "description": "Reset clears all room numbers"
    },
    {
        "field": "Status",
        "description": "Reset resets status to catalog status"
    }
]

export const plans = [{
    label: 'Healthcare Professional- Basic', value: 1
}, {
    label: 'Healthcare Professional- Standard', value: 2
},
{
    label: 'Architects/Planners/Consultants- Basic', value: 3
},
{
    label: 'Architects/Planners/Consultants- Standard', value: 4
},
{
    label: 'Architects/Planners/Consultants- Enterprise', value: 5
}, {
    label: 'Student', value: 6
},
{
    label: 'Supplier', value: 7
}];

export const TwoDAccess = [2, 4, 5];
export const ThreeDAccess = 5;

export const BasicAccess = [1, 3, 6];
export const StandardAccess = [2, 4];
export const EnterpriseAccess = 5;


export function isDateWithinNext15Days(dateStr) {
    if (!dateStr) return false;

    const endDate = new Date(dateStr);
    const today = new Date();
    const in15Days = new Date();

    // Zero out the time part for accurate date-only comparison
    today.setHours(0, 0, 0, 0);
    in15Days.setDate(today.getDate() + 30);
    in15Days.setHours(0, 0, 0, 0);

    endDate.setHours(0, 0, 0, 0);

    return endDate >= today && endDate <= in15Days;
}

export const appendIfNotNull = (formData, key, value) => {
    if (value !== null && value !== undefined && value !== '') {
        formData.append(key, value);
    }
};

export const bidFormSections = [
    {
        id: 1,
        type: 'purpose',
        description: '',
    },
    {
        id: 2,
        title: 'A',
        isdefault: true,
        sectionName: 'Operational requirements',
        requirements: [
            {
                id: 1,
                code: 'A.1',
                description: '',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'dropdown',
                attachment: false
            }
        ]
    },
    {
        id: 3,
        title: 'B',
        isdefault: true,
        sectionName: 'Specifications',
        requirements: [
            {
                id: 1,
                code: 'B.1',
                description: '',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'dropdown',
                attachment: false
            }
        ]
    },
    {
        id: 4,
        title: 'C',
        isdefault: true,
        sectionName: 'Standards & Safety',
        requirements: [
            {
                id: 1,
                code: 'C.1',
                description: 'Should be preferably be FDA or CE or ISI approved product. (Please specify Approval Standard)',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 2,
                code: 'C.2',
                description: 'It should meet the requirements of the National Fire Protection Association (NFPA)',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            }
        ]
    },
    {
        id: 5,
        title: 'D',
        isdefault: true,
        sectionName: 'Environmental Factors / Operating Conditions',
        requirements: [
            {
                id: 1,
                code: 'D.1',
                description: 'Specify operating conditions required to be fulfilled by equipment',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 2,
                code: 'D.2',
                description: 'Ambient Temperature',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 3,
                code: 'D.3',
                description: 'Relative Humidity',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 4,
                code: 'D.4',
                description: 'Other',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            }
        ]
    },
    {
        id: 6,
        title: 'E',
        isdefault: true,
        sectionName: 'Physical Requirments',
        requirements: [
            {
                id: 1,
                code: 'E.1',
                description: 'Width',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 2,
                code: 'E.2',
                description: 'Depth',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 3,
                code: 'E.3',
                description: 'Height',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            }
        ]
    },
    {
        id: 7,
        title: 'F',
        isdefault: true,
        sectionName: 'Utility Requirments',
        requirements: [
            {
                id: 1,
                code: 'F.1',
                description: 'Electrical (Volts, Amp, Watts)',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 2,
                code: 'F.2',
                description: 'Mechanical (Vent, Heat Dissipation)',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 3,
                code: 'F.3',
                description: 'Plumbing (Hot/Cold/Treated Water, Steam, Vac, Drain)',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 4,
                code: 'F.4',
                description: 'Medgas (Medical Air, Instrument Air, O2, etc)',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 5,
                code: 'F.5',
                description: 'IT / Network (RJ45, RJ11, HDMI, Cat6 etc)',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            }
        ]
    },
    {
        id: 8,
        title: 'G',
        isdefault: true,
        sectionName: 'Attachments',
        requirements: [
            {
                id: 1,
                code: 'G.1',
                description: 'Attachment 1',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            },
            {
                id: 2,
                code: 'G.2',
                description: 'Attachment 2',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            }
        ]
    },
    {
        id: 9,
        title: 'H',
        isdefault: true,
        sectionName: 'Accessories (If Any)',
        requirements: [
            {
                id: 1,
                code: 'H.1',
                description: 'List Accessories compulsory for items quotes against above specifiations. \n**The Cost of each Accessory must be Quoted separately in financial offer',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: true
            }
        ]
    },
    {
        id: 10,
        title: 'I',
        isdefault: true,
        sectionName: 'Consumables (if Any)',
        requirements: [
            {
                "id": 1,
                "code": "I.1",
                "description": "List Consumables compulsory for items quotes against above specifiations.",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": false
            },
            {
                "id": 2,
                "code": "I.2",
                "description": "The Cost of each Consumables must be Quoted separately.",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": false
            }
        ]
    },
    {
        id: 11,
        title: 'J',
        isdefault: true,
        sectionName: 'Optional Items and Requirements',
        requirements: [
            {
                id: 1,
                code: 'J.1',
                description: 'Specify any optional items or software required for full equipment functionality or additional features not included in the basic specifications. Quote price sperately in financial offer for each optional items ',
                response: '',
                remarks: '',
                attachments: [],
                responseType: 'textfield',
                attachment: false
            }
        ]
    },
    {
        id: 12,
        title: 'K',
        isdefault: true,
        sectionName: 'Warranty & Service',
        requirements: [
            {
                "id": 1,
                "code": "K.1",
                "description": "Comprehensive Warranty for 1 yrs. (List any exclusions if applicable)",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "dropdown",
                "attachment": false
            },
            {
                "id": 2,
                "code": "K.2",
                "description": "Please Specify the percentage of uptime Guarantee of Equipment during Warranty.",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "dropdown",
                "attachment": false
            },
            {
                "id": 3,
                "code": "K.3",
                "description": "The Cost of Comprehensive Maintenance Contract (CMC) must be Quoted separately.",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "dropdown",
                "attachment": false
            },
            {
                "id": 4,
                "code": "K.4",
                "description": "The Cost of Annual Maintenance Contract (AMC) must be Quoted separately.",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "dropdown",
                "attachment": false
            },
            {
                "id": 5,
                "code": "K.5",
                "description": "Please Specify the percentage of uptime Guarantee of Equipment during AMC and CMC",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "dropdown",
                "attachment": false
            },
            {
                "id": 6,
                "code": "K.6",
                "description": "After Sales, Service must be provided in the Hospital. In the Situations requiring service / repair of the unit outside the City of installation, the Expenditure on account of this have to be born by the Supplier",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "dropdown",
                "attachment": false
            }
        ]
    },
    {
        id: 13,
        title: 'L',
        isdefault: true,
        sectionName: 'Training',
        requirements: [
            {
                "id": 1,
                "code": "L.1",
                "description": "Comprehensive Training to for Staff of user department and Support service till Familiarity with the System.",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "dropdown",
                "attachment": false
            }
        ]
    },
    {
        id: 14,
        title: 'M',
        isdefault: true,
        sectionName: 'Financial Offer',
        requirements: [
            {
                "id": 1,
                "code": "M.1",
                "description": "Basic Price (Along with Attachments pdf & Images)\n(this should include price of item quoted for requested specifications and all other expanses associated with supply and installation)",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": true
            },
            {
                "id": 2,
                "code": "M.2",
                "description": "Accessories (Vendor to Attach pdf & Images)\n(this should include price of Accessories quoted)",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": true
            },
            {
                "id": 3,
                "code": "M.3",
                "description": "Consumables (Vendor to Attach pdf & Images)\n(this should include price of Consumables quoted)",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": true
            },
            {
                "id": 4,
                "code": "M.4",
                "description": "Optional Items (Vendor to Attach pdf & Images)\n(this should include price of Optional Items quoted)",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": true
            },
            {
                "id": 5,
                "code": "M.5",
                "description": "Cost of Annual Maintenance Contract (AMC)\n(Vendor to Attach detailed terms & conditions on inclusion/exclusion in pdf)",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": true
            },
            {
                "id": 6,
                "code": "M.6",
                "description": "Cost of Comprehensive Maintenance Contract (CMC) (Vendor to Attach detailed terms & conditions on inclusion/exclusion in pdf)",
                "response": "",
                "remarks": "",
                "attachments": [],
                "responseType": "textfield",
                "attachment": true
            }
        ]
    }
]

// Dropdowns
export const Condtions = [{
    name: 'New', value: 'new'
}, {
    name: 'Excellent', value: 'excellent'
}, {
    name: 'Good', value: 'good'
}, {
    name: 'Fair', value: 'Fair'
}];

export const Scope = [{
    "name": "Project", "value": "project"
}, {
    "name": "Item", "value": "item"
}];


export const TaxableOption = [{
    name: 'Freight', value: 'Freight'
}, {
    name: 'Installation', value: 'Installation'
}, {
    name: 'Storage', value: 'Storage'
}, {
    name: 'Fees', value: 'Fees'
}];

export const PAStatus = [
    {
        "name": "Approved",
        "value": "approved"
    },
    {
        "name": "Cancelled",
        "value": "cancelled"
    },
    {
        "name": "Completed",
        "value": "completed"
    },
    {
        "name": "In Progress",
        "value": "in-progress"
    },
    {
        "name": "Issued",
        "value": "issued"
    },
    {
        "name": "Rejected",
        "value": "rejected"
    },
];


export const OrgType = [{
    label: 'Hospital', value: 'hospital'
}, {
    label: 'Facilitator', value: 'facilitator'
}, {
    label: 'Architect', value: 'architect'
}, {
    label: 'Planner', value: 'planner'
}, {
    label: 'Trust', value: 'trust'
}, {
    label: 'Government', value: 'government'
}]

export const ProviderType = [{
    name: 'Manufacturer', value: 'manufacturer'
}, {
    name: 'Vendor', value: 'vender'
}];

export const InvoiceStatus = [{
    label: 'Received', value: 'received'
}, {
    label: 'Approved', value: 'approved'
}, {
    label: 'Partially Paid', value: 'partiallypaid'
}, {
    label: 'Paid', value: 'paid'
}, {
    label: 'Cancelled', value: 'cancelled'
}];


export const DropdownTypes = {
    PROJECT_TYPE: 'project_type',
    FUNDING_SOURCE: 'funding_source',
    PRODUCT_TYPE: 'product_type',
    DRAIN_LOCATION: 'drain_location',
    GAS_TYPE: 'gas_type',
    GAS_LOCATION: 'gas_location',
    DISSIPATION_TYPE: 'dissipation_type',
    VENT_TYPE: 'vent_type',
    PROJECT_UNIT: 'project_unit',
    CURRENCY: 'currency',
    CONNECTION_TYPE: 'connection_type',
    VOLTAGE_TYPE: 'voltage_type',
    PLUG_TYPE: 'plug_type',
    HERTZ: 'hertz',
    ITEM_STATUS: 'item_status',
    SHIELDING: 'shielding',
    MOUNTING: 'mounting',
    BUDGET_TYPE: 'budget_type',
    PROJECT_STATUS: 'project_status',
    VOLTS: 'volts',
    ELECTRICAL_PHASE: 'electrical_phase',
    BUILDING_TYPE: 'building_type',
    NETWORK: 'network',
    ACTION_STAGE: 'action_stage',
    DEPARTMENT_TYPE: 'department_type'
};

// doing
let response;
if (localStorage.getItem('token') !== null) {
    response = await apiRequest('get', '/dropdown');
}
const customFields = response?.data?.data || [];

const getDropdowns = (customFields, type) => {
    return customFields.find((a) => a.type === type)?.data
};

export const Units = getDropdowns(customFields, DropdownTypes.PROJECT_UNIT) || [];
export const projectStatus = getDropdowns(customFields, DropdownTypes.PROJECT_STATUS) || [];
export const projectType = getDropdowns(customFields, DropdownTypes.PROJECT_TYPE) || [];
export const FundingSource = getDropdowns(customFields, DropdownTypes.FUNDING_SOURCE) || [];
export const ProjectUnit = getDropdowns(customFields, DropdownTypes.PROJECT_UNIT) || [];
export const CurrencyJSON = getDropdowns(customFields, DropdownTypes.CURRENCY) || [];
export const ProductType = getDropdowns(customFields, DropdownTypes.PRODUCT_TYPE) || [];
export const ConnectionType = getDropdowns(customFields, DropdownTypes.CONNECTION_TYPE) || [];
export const Network = getDropdowns(customFields, DropdownTypes.NETWORK) || [];
export const DrainLocation = getDropdowns(customFields, DropdownTypes.DRAIN_LOCATION) || [];
export const GasType = getDropdowns(customFields, DropdownTypes.GAS_TYPE) || [];
export const GasLocation = getDropdowns(customFields, DropdownTypes.GAS_LOCATION) || [];
export const DissipationType = getDropdowns(customFields, DropdownTypes.DISSIPATION_TYPE) || [];
export const VentType = getDropdowns(customFields, DropdownTypes.VENT_TYPE) || [];
export const VoltageType = getDropdowns(customFields, DropdownTypes.VOLTAGE_TYPE) || [];
export const Volts = getDropdowns(customFields, DropdownTypes.VOLTS) || [];
export const Hertz = getDropdowns(customFields, DropdownTypes.HERTZ) || [];
export const ElectricalPhase = getDropdowns(customFields, DropdownTypes.ELECTRICAL_PHASE) || [];
export const PlugType = getDropdowns(customFields, DropdownTypes.PLUG_TYPE) || [];
export const Shielding = getDropdowns(customFields, DropdownTypes.SHIELDING) || [];
export const Mounting = getDropdowns(customFields, DropdownTypes.MOUNTING) || [];
export const BuildingType = getDropdowns(customFields, DropdownTypes.BUILDING_TYPE) || [];
export const DepartmentType = getDropdowns(customFields, DropdownTypes.DEPARTMENT_TYPE) || [];
export const ItemStatus = getDropdowns(customFields, DropdownTypes.ITEM_STATUS) || [];
export const ActionStage = getDropdowns(customFields, DropdownTypes.ACTION_STAGE) || [];
export const BudgetType = getDropdowns(customFields, DropdownTypes.BUDGET_TYPE) || [];

export const tableNames = [
    {
        value: 'Project', label: 'Project'
    },
    {
        value: 'Building', label: 'Building'
    },
    {
        value: 'Level', label: 'Level'
    },
    {
        value: 'Department', label: 'Department'
    },
    {
        value: 'Room', label: 'Room'
    },
    {
        value: 'Item', label: 'Item'
    }
]

export const Actions = [
    {
        value: 'Added', label: 'Added'
    },
    {
        value: 'Edited', label: 'Edited'
    },
    {
        value: 'Deleted', label: 'Deleted'
    }
]